<template>
  <div class="tournament-list">
    <div class="main-header">
      <div class="container">
        <div class="header-wrapper">
          <div class="header-left">
            <h1>Campeonatos</h1>
          </div>

          <div class="header-right" style="text-align: right" v-if="false">
            <router-link
              :to="{ name: 'TournamentCreate' }"
              class="btn btn-primary btn-large"
            >Crie um campeonato</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <TournamentCard
          :tournament="tournament"
          v-for="tournament in tournaments.filter(t => t.active)"
          :key="tournament.id"
          columnClass="col-6 col-md-4"
        ></TournamentCard>
      </div>

      <!-- <div class="row">
        <div class="col-12">
          <h4>torneios encerrados</h4>
        </div>
        <TournamentCard
          :tournament="tournament"
          v-for="tournament in tournaments.filter(t => !t.active)"
          :key="tournament.id"
          columnClass="col-6 col-lg-3"
        ></TournamentCard>
      </div> -->

      </div>
      
      </div>
    </div>
  </div>
</template>

<script>
// import BlogpostCard from '@/components/BlogpostCard'
import Header from "@/components/Header";
import TournamentCard from "@/components/TournamentCard";
export default {
  name: "TournamentList",
  metaInfo: {
    title: "Campeonatos e torneios"
  },
  data() {
    return {
      tournaments: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("tournaments.json")
        .then(response => (this.tournaments = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header,
    TournamentCard
  }
};
</script>

<style lang="sass">
body.tournament-page
  .tournament-listing
</style>
